import React, { useCallback, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import Scanner from '../Scanner';

import identificationsApi from '../../apis/identifications';

const DigimarcScanner = ({ onFindCode, intervalMs, ...props }) => {
	const onFindCodeRef = useRef();

	onFindCodeRef.current = onFindCode;

	const [isScanning, setIsScanning] = useState(true);

	const onScan = useCallback(
		async (img) => {
			try {
				setIsScanning(false);

				const response = await identificationsApi.identifyDigimarc(img);

				if (response.length) {
					onFindCodeRef.current(response[0], img);
				} else {
					setIsScanning(true);
				}
			} catch (e) {
				setIsScanning(true);
			}
		},
		[onFindCodeRef]
	);

	return (
		<Scanner
			isScanning={isScanning}
			onScan={onScan}
			intervalMs={intervalMs}
			{...props}
		/>
	);
};

DigimarcScanner.propTypes = {
	onFindCode: PropTypes.func.isRequired,
	intervalMs: PropTypes.number,
};

DigimarcScanner.defaultProps = {
	intervalMs: 1000,
};

export default DigimarcScanner;
